export const gtm = (id?: string) =>
  id
    ? `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');
  `
    : '';

// Read by the exception trigger of the CookieYes tag in GTM, so it has to be in dataLayer before gtm.js loads
const cookieYesDisabled = `
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ cookieyes_disabled: true });
`;

export const getGtmScript = (id: string | undefined, withCookieYesDisabled: boolean): string => {
  const script = gtm(id);
  if (script && withCookieYesDisabled) return `${cookieYesDisabled}${script}`;

  return script;
};

export const gtg = (id?: string) =>
  id
    ? `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s);j.async=true;j.src=
    window.location.origin+'/metrics/gtm.js?id='+i;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');
  `
    : '';
